<!-- 要求：
  PC、移动适应 -->

<!-- 表单：
 客  户 ：
 描  述：（场景及需求描述）：
 提交人：
 备  注：
 -->
<template>
  <el-row style="min-height: calc(100vh);background: linear-gradient(200deg,#e3c5ed,#a9c1ed);" >
    <el-col :span='24' >
      <el-row style="margin: 1.25rem; margin-top: 6.875rem; background-color: white;border-radius: 0.9375rem; padding: 1.25rem" class="login-main">
        <el-form ref="form" :model="form" label-width="80px"  label-position="left" style="">
          <h3 style="text-align: center; letter-spacing:0.4375rem;margin-bottom: 1.875rem;">药知平台问题反馈</h3>
          <el-form-item >
             <label slot="label">客&nbsp;&nbsp;户 ：</label>
            <el-input v-model="form.company" placeholder="请输入客户名称"></el-input>
          </el-form-item>
          <el-form-item >
            <label slot="label">名&nbsp;&nbsp;称 ：</label>
            <el-input v-model="form.name" placeholder="用简洁的短语描述需求，要给用户提供什么功能，比如黑名单" type="textarea"></el-input>
          </el-form-item>
          <el-form-item >
            <label slot="label">描&nbsp;&nbsp;述 ：</label>
            <el-input v-model="form.needs" placeholder="场景及需求描述" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="提交人：">
            <el-input v-model="form.submitter" placeholder="请输入提交人"></el-input>
          </el-form-item>
          <el-form-item>
            <label slot="label">备&nbsp;&nbsp;注 ：</label>
            <el-input v-model="form.other" placeholder="请输入备注" type="textarea"></el-input>
          </el-form-item>
        </el-form>
        <el-row style="text-align: center;margin-top: 1.875rem;">
          <el-button type="primary" @click="onSubmit" style="letter-spacing:0.3125rem;background: linear-gradient(-200deg,#e3c5ed,#a9c1ed);border-color: white;">立即提交</el-button>
        </el-row>
      </el-row>

    </el-col>
  </el-row>
</template>

<script>
  export default {
    data() {
      return {
        form: {
          company: '',//客户
          submitter:'',//提交人
          needs:'',//描述
          other:'',//备注
          name:'',//名称

        },
      }
    },
    mounted: function() {
    },
    methods: {
      onSubmit() {
        let _this=this
        _this.axios.post("/v2/share/needs_save",{needs:_this.form}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.$message.success(res.data.msg)
              _this.form={}
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

    }
  }
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/view/share/other/needs.vue